


















import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  computed: {
    isActivePath() {
      return (name) => {
        const { path } = this.$route;
        return path.startsWith(name);
      };
    },
  },
});

interface Props {}

interface Data {}

interface Computed {
  isActivePath(name: string): boolean;
}

interface Methods {}
